export enum OrderComplaintType {
  DamagedGoods = 'damaged_goods',
  LateDelivery = 'late_delivery',
  Aggression = 'aggression',
  IncorrectInvoice = 'incorrect_invoice',
  IncorrectDelivery = 'incorrect_delivery',
  Other = 'other',
}

export enum BusinessUnit {
  Benelux = 0,
  France = 1,
  Germany = 2,
  Forwarding = 3,
}

export enum OrderDateFilterType {
  Load = 'Load',
  Unload = 'Unload',
  Creation = 'Creation',
}
